import getImageSizeBasedOnViewport from './getImageSizeBasedOnViewport';
export default getImageSizeBasedOnViewport;